export default function(context, scene) {
  var group = scene.group;
  context.save();
  context.beginPath();
  context.rect(0, 0, group.width || 0, group.height || 0);
  context.clip();
}



//////////////////
// WEBPACK FOOTER
// ./~/vega-scenegraph/src/util/canvas/clip.js
// module id = 1488
// module chunks = 0